import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ProductIdentity} from '../models/product.model';
import {CpiOfferRecalculationRequest, CpiSalesConfiguration, OfferCpi} from '../models/offer.model';
import {PolicyCpi} from '../models/policy.model';
import {AvailableQuestionnaire, FilledQuestionnaire} from '../models/questionnaire.model';

@Injectable()
export class SalesCpiService {

    baseUrl = '/api/secured/sales/cpi';
    offerUrl = `${this.baseUrl}/offer`;

    constructor(private http: HttpClient) {
    }

    /**
     * fetch single offer
     */
    getOffer(offerId: number) {
        return this.http.get<OfferCpi>(`${this.offerUrl}/${offerId}`);
    }

    /**
     * fetch product list
     */
    fetchProducts() {
        return this.http.get<ProductIdentity[]>(`${this.baseUrl}/product-list`);
    }

    /**
     * @param productId - cpi product id
     */
    createOffer(productId: number) {
        return this.http.post<OfferCpi>(this.offerUrl, {productId});
    }

    /**
     *
     * @param offerId       - cpi offer id
     * @param configuration - cpi offer configuration (basic info)
     */
    simulate(offerId: number, configuration: CpiOfferRecalculationRequest) {
        return this.http.put<OfferCpi>(`${this.offerUrl}/${offerId}`, configuration);
    }

    /**
     *
     * @param offerId   - cpi offer id
     * @param code      - variant code
     */
    selectVariant(offerId: number, code: string) {
        return this.http.put<OfferCpi>(`${this.offerUrl}/${offerId}/variant`, {code});
    }

    /**
     *
     * @param offerId       - cpi offer id
     * @param configuration - cpi offer configuration (full info)
     */
    issue(offerId, configuration: CpiSalesConfiguration) {
        return this.http.post<PolicyCpi>(`${this.offerUrl}/${offerId}/issue`, configuration);
    }

    getQuestionnaire(offerId: number) {
        return this.http.get<AvailableQuestionnaire>(`${this.offerUrl}/${offerId}/available-questionnaire`);
    }

    validateQuestionnaire(offerId: number, payload: FilledQuestionnaire) {
        return this.http.put<OfferCpi>(`${this.offerUrl}/${offerId}/questionnaire`, {...payload});
    }
}
